import React, { useState, useContext, useEffect } from 'react';
import { ConfigContext } from 'store/context';
import { Layout, Drawer } from 'antd';
import { useWindowSize } from 'react-use';
import { SidebarCollapse } from 'store/actions/ConfigAction';
import SideDrawer from 'components/SideDrawer';
import { TAB_SIZE, WIDTH_MENU } from '../../constants/ThemeSetting';
import SidebarContent from './SidebarContent';

const { Sider } = Layout;
function Sidebar() {
  const [openDrawer, setOpenDrawer] = useState(undefined);
  const [drawer, setDrawer] = useState('');
  const { width } = useWindowSize();
  const {
    ConfigState: { statusCollapse: status, hasSidebar },
    ConfigDispatch,
  } = useContext(ConfigContext);
  useEffect(() => {
    if (openDrawer === false) {
      setDrawer('');
    }
  }, [openDrawer]);
  const toogleSubmenu = drawerName => {
    if (drawerName) {
      const currentDrawer = drawer;
      setDrawer(drawer === drawerName ? '' : drawerName);
      if (currentDrawer === drawerName || !currentDrawer) {
        setOpenDrawer(!openDrawer);
      }
    } else {
      setDrawer('');
      setOpenDrawer(false);
    }
  };
  return (
    <>
      {hasSidebar && (
        <>
          {width > TAB_SIZE ? (
            <Sider trigger={null} width={WIDTH_MENU} theme="lite" collapsible collapsed={status}>
              <SidebarContent toogleSubmenu={toogleSubmenu} drawer={drawer} openDrawer={openDrawer} />
            </Sider>
          ) : (
            <Drawer
              zIndex={100}
              width={WIDTH_MENU}
              placement="left"
              closable={false}
              className="omi-menu-mobile"
              onClose={() => ConfigDispatch(SidebarCollapse())}
              visible={status}
            >
              <SidebarContent toogleSubmenu={toogleSubmenu} drawer={drawer} openDrawer={openDrawer} />
            </Drawer>
          )}
          <SideDrawer show={openDrawer} setOpenDrawer={setOpenDrawer} drawer={drawer} collapsed={status} />
        </>
      )}
    </>
  );
}

export default Sidebar;
